import { useEffect } from "react";
import { useNotification } from "../../Context/NotificationContext";
import messages from "../../Service/Notification/messages";
import NotificationService from "../../Service/Notification/notification.service";
import { getRemainingDays } from "../../Utils/generic-functions";
import useAccess from "../../Hooks/useAccess";

const useApplicationLimit = () => {
  const { currentLimits, currentSubscription } = useAccess();
  const { setShow } = useNotification();
  const daysOfSubscriptionPending = getRemainingDays(
    currentSubscription?.endDate,
  );

  const checkApplicationLimit = () => {
    const applicationsProcessed =
      currentSubscription?.measurements?.applicationsProcessed;
    const applicationLimit = currentLimits?.applicationsProcessed;
    if (applicationsProcessed !== undefined && applicationLimit !== undefined) {
      if (applicationsProcessed >= applicationLimit - 25) {
        const { message, title } = messages["APPLICATION_LIMIT_REACHED"];
        NotificationService.getInstance().setCurrentMessage(
          message,
          title,
          { noOfApplications: applicationLimit },
          "",
        );
        setShow(true);
      } else {
        setShow(false);
      }
    } else {
      setShow(false);
    }
  };

  const handleExpiry = (isExpired: boolean) => {
    if (isExpired) {
      const { message, title } = messages["PLAN_EXPIRED"];
      NotificationService.getInstance().setCurrentMessage(
        message,
        title,
        "",
        "",
      );
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const handleExpiringSoon = (isExpiringSoon: boolean) => {
    if (isExpiringSoon) {
      const { message, title } = messages["PLAN_EXPIRES_SOON"];
      NotificationService.getInstance().setCurrentMessage(
        message,
        title,
        "",
        "",
      );
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    const isExpired = daysOfSubscriptionPending <= 0;
    const isExpiringSoon = daysOfSubscriptionPending <= 3;
    if (isExpired) {
      handleExpiry(isExpired);
    } else if (isExpiringSoon) {
      handleExpiringSoon(isExpiringSoon);
    } else {
      checkApplicationLimit();
    }
    return () => setShow(false);
  }, [daysOfSubscriptionPending, currentSubscription, currentLimits]);

  return null;
};

export default useApplicationLimit;
